import './style/index.less';
import BgPageWrapper from './BgPageWrapper';

export default BgPageWrapper;
